import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {CheckIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {PRICES_METHODOLOGY_POINTS} from "../constants/prices_methodology_points";

export const PricesMethodology = () => {
    return (
        <Container className={containerStyle}>
            <div className={cardStyle}>
                <Text variant="body_copy_0" as="h2" mb={1.5}>
                    Metodologia i źródła danych
                </Text>

                <div className={listStyle}>
                    {PRICES_METHODOLOGY_POINTS.map((point) => (
                        <div key={point} className={listItemStyle}>
                            <CheckIcon size="1.4" wrapperSize="1.8" wrapperColor="transparent" />
                            <Text variant="body_copy_2" as="p">
                                {point}
                            </Text>
                        </div>
                    ))}
                </div>
            </div>
        </Container>
    );
};

const containerStyle = css({
    py: 3,

    md: {
        py: 4
    }
});

const cardStyle = css({
    maxWidth: "115rem",
    m: "auto",
    backgroundColor: "var(--colors-gray-100)",
    borderRadius: 2,
    p: 2,

    md: {
        p: 3
    }
});

const listStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5
});

const listItemStyle = css({
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: 1.5
});
import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {CheckIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {PRICES_METHODOLOGY_POINTS} from "../constants/prices_methodology_points";

export const PricesMethodology = () => {
    return (
        <Container className={containerStyle}>
            <div className={cardStyle}>
                <Text variant="body_copy_0" as="h2" mb={1.5}>
                    Metodologia i źródła danych
                </Text>

                <div className={listStyle}>
                    {PRICES_METHODOLOGY_POINTS.map((point) => (
                        <div key={point} className={listItemStyle}>
                            <CheckIcon size="1.4" wrapperSize="1.8" wrapperColor="transparent" />
                            <Text variant="body_copy_2" as="p">
                                {point}
                            </Text>
                        </div>
                    ))}
                </div>
            </div>
        </Container>
    );
};

const containerStyle = css({
    py: 3,

    md: {
        py: 4
    }
});

const cardStyle = css({
    maxWidth: "115rem",
    m: "auto",
    backgroundColor: "var(--colors-gray-100)",
    borderRadius: 2,
    p: 2,

    md: {
        p: 3
    }
});

const listStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5
});

const listItemStyle = css({
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: 1.5
});
